// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UserSessionsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UserSessionsIcon" ref={forwardedRef} {...props}>
      <path d="M6.003 8.268H2V4.261h1.201v1.883a8.034 8.034 0 0 1 12.7-1.8 7.96 7.96 0 0 1 2.3 4.775 7.97 7.97 0 0 1-2.3 6.538 8.02 8.02 0 0 1-6.554 2.295 8 8 0 0 1-4.788-2.295 7.96 7.96 0 0 1-2.311-4.885H3.76a6.47 6.47 0 0 0 1.863 3.824 6.5 6.5 0 0 0 3.889 1.865 6.51 6.51 0 0 0 5.326-1.865 6.48 6.48 0 0 0 1.869-5.312 6.46 6.46 0 0 0-1.87-3.88A6.528 6.528 0 0 0 4.415 7.066h1.59z" />
      <path d="m14.76 10.019-7.005 4.006V6.012zM9.257 8.6v2.835l2.479-1.417z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UserSessionsIcon = /* @__PURE__ */ Object.assign(
  UserSessionsIconComponent,
  { displayName: 'UserSessionsIcon' },
);
